<template v-slot:listItem="{ item }" >
  <div class="lines" @click="select(item)">
    <div class="up">
      <div class="left">
        <span class="title"> {{item.nivel}}</span>
      </div>
      <div class="right">
        <div class="info">
          <gw-icon
            @click.stop="information(item)"
            icon="fa-info-circle"/>
        </div>

        <span class="value"  v-bind:style="`background-color:${valueColor}`">
          {{formatPercentage(item.desempenho)}}
        </span>
        <gw-icon class="next" icon="fa-chevron-right" v-if="item.filhos && item.filhos.length"/>
      </div>
    </div>
    <div class="down">
      <div class="values">
        <span class="val"> Un. Negócio: {{item.contagemUnidadeNegocio}}</span>
        <span class="val"> Indicadores: {{item.contagemIndicador}} </span>
        <span class="val" v-if="item.mediaValorMedicao"> Média: {{getValorMedia(item)}} </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Formatters,
  GwIcon,
  GwIconButton
} from 'guaxinim-web'

import {
  cores,
  legendColor,
  formatarValorMedia
} from './A7PainelDefaultConfigurations'

export default {
  name: "a7-painel-mobile-item",
  components: {
    Formatters,
    GwIcon,
    GwIconButton
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    hasNext: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    valueColor: cores.corNaoSeAplica
  }),
  methods: {
    select(item){
      this.$emit('selected', item)
    },
    information(item){
      this.$emit('information', item)
    },
    formatPercentage(value){
      this.valueColor = legendColor(value)
      return Formatters.percentFormat.format(Math.min(value, 100))
    },
    getValorMedia(item){
      return formatarValorMedia(item.mediaValorMedicao, item.medicaoUnidadeMedida)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'guaxinim-web/src/css/color-palette.scss';
@import './A7PainelFormatacao';

.lines {
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  background-color: white;
  width: 100%;
  .up,.down {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .up {
    align-items: flex-end;
    .left {
      flex: 1;
      display: flex;
      align-items: flex-end;
      .title {
        font-size: $tamanhoFonteMedia;
        font-weight: $weight;
      }
    }
    .right {
      display: flex;
      height: auto;
      align-items: center;
      font-weight: $weight;
      .value {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        color: $white;
        border: 1px solid transparent;
        box-shadow: 0 2px 3px $grey-light;
        min-width: 60px;
        min-height: 25px;
      }
      .next{
        color: $grey-dark;
        margin-left: 10px;
        font-size: 16px;
      }
      .info {
        color: $default;
        margin-right: 10px;
        height: 100%;
        font-size: 20px;
      }
    }
  }
  .down {
    .values{
      color: $grey-darker;
      font-size: $tamanhoFontePequena;
      width: 100%;
      margin-top: 5px;
      .val:not(last-child) {
        margin-right: 10px;
      }
    }
  }

}


</style>
